<div class="flex items-center mb-32">
    <div class="progressbar">
        <input
            class="timeline_progress"
            type="range"
            min="0"
            max="1"
            step="any"
            value="0"
        />
        <div class="timeline_markers" aria-hidden="true"></div>
        <span class="catchup-ad-debug hidden" aria-hidden="true"></span>
        <div id="timeline_preview" class="timeline_preview hidden"></div>
    </div>
    <div class="progressbar__time">
        <span class="time_now">00:00</span> / <span class="duration">00:00</span>
    </div>
</div>
